import { render, staticRenderFns } from "./HeaderBar.vue?vue&type=template&id=c2fd5978"
import script from "./HeaderBar.vue?vue&type=script&lang=js"
export * from "./HeaderBar.vue?vue&type=script&lang=js"
import style0 from "./HeaderBar.vue?vue&type=style&index=0&id=c2fd5978&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports